import {createOpenCanvasConfig} from '@packages/systems/open-canvas/core';
import {componentCanvasOpenCanvasConfig} from '@packages/systems/component-canvas/designer';
import {multiContextCanvasOpenCanvasConfig} from '@packages/systems/multi-context-canvas/designer';

/**
 * The top-level Open Canvas integration config for the Designer.
 *
 * If you're adding a new feature that utilizes the Open Canvas & Frames, you'll want
 * to create a new config for your feature and add it to this object.
 */
export const OpenCanvas = createOpenCanvasConfig({
  features: {
    componentCanvas: componentCanvasOpenCanvasConfig,
    multiContextCanvas: multiContextCanvasOpenCanvasConfig,
  },
});
